import { GitMerge, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface CoverageActionButtonsProps {
  selectedCount: number;
  onDeleteSelected: () => void;
  onMergeSelected: () => void;
  isDeleting?: boolean;
}

export const CoverageActionButtons = ({
  selectedCount,
  onDeleteSelected,
  onMergeSelected,
  isDeleting = false,
}: CoverageActionButtonsProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-2 p-4 bg-white border-b border-gray-200">
      <span className="text-sm text-gray-600 mr-4">
        {selectedCount} coverage{selectedCount === 1 ? '' : 's'} selected
      </span>

      <Button
        variant="outline"
        size="sm"
        onClick={onDeleteSelected}
        disabled={isDeleting}
        className="gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
      >
        <Trash2 className="h-4 w-4" />
        Delete Selected
      </Button>

      {selectedCount >= 2 && (
        <Button
          variant="outline"
          size="sm"
          onClick={onMergeSelected}
          className="gap-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
        >
          <GitMerge className="h-4 w-4" />
          Merge Selected
        </Button>
      )}
    </div>
  );
};
